import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { RigaConversazioneYuma } from '@shared/yuma-sito/tipi';
import { tokens } from '../../theme';
import { conversazioniDellIscritto } from '../../services/yumaSitoService';
import { GattoPiccolo } from './Trascrizione';

/**
 * Nella scheda di un iscritto alla lista d'attesa: le conversazioni con Yuma sul sito da cui è nata l'iscrizione
 * (30/10/2026). Se non ce ne sono non mostra niente: la maggior parte degli iscritti arriva dal modulo diretto.
 * Un errore di lettura non disturba la scheda: si registra in console e la sezione resta nascosta.
 */
export const ConversazioniDellIscritto: React.FC<{ leadId: string }> = ({ leadId }) => {
  const { t } = useTranslation('yumaSito');
  const [righe, setRighe] = useState<RigaConversazioneYuma[]>([]);

  useEffect(() => {
    let viva = true;
    setRighe([]);
    conversazioniDellIscritto(leadId)
      .then((r) => viva && setRighe(r))
      .catch((e) => console.warn('[yumaSito] conversazioni dell’iscritto non lette', e));
    return () => {
      viva = false;
    };
  }, [leadId]);

  if (righe.length === 0) return null;
  return (
    <Box sx={{ mt: 2, p: 1.5, display: 'flex', alignItems: 'center', gap: 1.5, borderRadius: `${tokens.radius.md}px`, border: `1px solid ${tokens.color.line}` }}>
      <GattoPiccolo lato={32} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontWeight: 650, fontSize: '0.9rem' }}>{t('iscritto.titolo')}</Typography>
        <Typography variant="body2" color="text.secondary">
          {t('elenco.messaggi', { count: righe[0].n_messaggi })}
        </Typography>
      </Box>
      <Button component={RouterLink} to={`/yuma-sito?c=${righe[0].id}`} size="small" variant="outlined">
        {t('iscritto.apri')}
      </Button>
    </Box>
  );
};
